module.exports = __webpack_public_path__ + "img/9791156330882.514572d8.jpg";